import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { DataCard, CardHeader, useStatusMessage } from '../../components';
import { TaskListHeader } from './TaskListHeader';
import { TaskLine } from './TaskLine';
import { retrieveSharedTasks } from '../../utilities/Database.mjs';

const SharedTasksView = () => {
  const { shareId } = useParams();
  const [shared, setShared] = useState(null);
  const [tasks, setTasks] = useState(null);
  const [StatusMessage, { showLoading, showError, hideStatus }] = useStatusMessage();

  useEffect(() => {
    async function load() {
      try {
        showLoading('Loading shared tasks...');
        const record = await retrieveSharedTasks(shareId);
        if (!record) {
          showError('Shared tasks not found. The link may have expired or been deleted.');
          return;
        }
        setShared(record);
        const parsed = record.tasksJson ? JSON.parse(record.tasksJson) : [];
        setTasks(parsed);
        hideStatus();
      } catch (err) {
        showError(err);
      }
    }
    load();
  }, [shareId, showLoading, showError, hideStatus]);

  const noop = useCallback(() => {}, []);

  return (
    <div className='container pb-2'>
      <StatusMessage />

      {shared && (
        <DataCard
          header={
            <CardHeader
              text={`Shared Tasks${shared.itemName ? ` — ${shared.itemName}` : ''}`}
            />
          }
          body={
            <div className='tasks-container'>
              {tasks && tasks.length > 0 ? (
                <div className='tasks'>
                  <TaskListHeader />
                  <div className='tasks-wrapper'>
                    {tasks.map((task, index) => (
                      <TaskLine task={task} key={index} onTaskClicked={noop} />
                    ))}
                  </div>
                </div>
              ) : (
                <p className="text-muted">No tasks in this shared view.</p>
              )}
              <p className="text-muted small mt-3">
                Shared by {shared.owner} &middot; Snapshot taken {new Date(shared.createdAt).toLocaleDateString()}
              </p>
            </div>
          }
        />
      )}
    </div>
  );
};

export default SharedTasksView;
